// Runtime config accessor (the zehn SPA contract — zehnmind/zehn-ci-workflows
// templates/spa). Read EVERY tier-specific value through `env()`, never
// `import.meta.env` directly.
//
// The container writes the pod's config into /env-config.js at start
// (docker/40-env-config.sh → window.__ENV__), and index.html loads it as a
// classic script before the app, so module-level reads already see it. The
// image is built with none of these values: the same bytes run on staging and
// on any other cluster. `buildEnv` is the fallback for `npm run dev`, where
// Vite supplies them; Vite only inlines LITERAL `import.meta.env.VITE_X`
// reads, hence the static map.
const buildEnv = {
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_COLLABORA_URL: import.meta.env.VITE_COLLABORA_URL,
  VITE_EIMZO_API_KEYS: import.meta.env.VITE_EIMZO_API_KEYS,
  // Comma-separated framer origins allowed to hand us an ID token (SET_ID_TOKEN).
  VITE_EMBED_ORIGINS: import.meta.env.VITE_EMBED_ORIGINS,
  // The zehn-aip doc agent panel (…/doc-agent-panel/) the editor's dock frames,
  // and the APIs of the other modules its agent may act in, as JSON
  // ({"zehn-abat": "https://abat-api…"}); docs' own API is added by itself.
  VITE_AIP_PANEL_URL: import.meta.env.VITE_AIP_PANEL_URL,
  VITE_AIP_MODULE_APIS: import.meta.env.VITE_AIP_MODULE_APIS,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  VITE_SENTRY_TRACES_SAMPLE_RATE: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
};

export const env = (key) => {
  const runtimeValue = typeof window !== 'undefined' ? window.__ENV__?.[key] : undefined;
  if (typeof runtimeValue === 'string' && runtimeValue !== '') {
    return runtimeValue;
  }
  return buildEnv[key];
};

// What this deploy calls itself: the chart's appVersion (the snapshot on
// staging, X.Y.Z once this same image is promoted) and its tier. Empty in
// `npm run dev`.
export const runtimeRelease = () => (typeof window !== 'undefined' && window.__RELEASE__) || {};
